import { PillTheme } from "@redotech/redo-model/pill-theme";
import {
  BadgeIcon,
  RedoBadge,
  RedoBadgeColor,
  RedoBadgeSize,
} from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import XIcon from "@redotech/redo-web/icon-old/x.svg";
import { filterTruthy } from "@redotech/util/array";
import classNames from "classnames";
import { memo } from "react";
import * as conversationTagInputCss from "./conversation-tag-input.module.css";

interface ConversationTagLike {
  name: string;
  pillTheme: PillTheme;
}

export const ConversationTagPillThemes = [
  PillTheme.NORMAL,
  PillTheme.PRIMARY_LIGHT,
  PillTheme.LIGHT_PINK,
  PillTheme.DANGER,
  PillTheme.NEUTRAL_YELLOW,
  PillTheme.SUCCESS,
  PillTheme.NEUTRAL_BLUE,
];

export const BadgePillThemeToColorMapping: Record<PillTheme, RedoBadgeColor> = {
  [PillTheme.NORMAL]: "gray",
  [PillTheme.PRIMARY_LIGHT]: "purple",
  [PillTheme.LIGHT_PINK]: "pink",
  [PillTheme.DANGER]: "orange",
  [PillTheme.NEUTRAL_YELLOW]: "warning",
  [PillTheme.SUCCESS]: "success",
  [PillTheme.NEUTRAL_BLUE]: "blueLight",
  [PillTheme.PRIMARY]: "purple",
  [PillTheme.SOLID_PINK]: "pink",
  [PillTheme.SOLID_RED]: "error",
  [PillTheme.SOLID_ORANGE]: "orange",
  [PillTheme.SOLID_YELLOW]: "warning",
  [PillTheme.SOLID_GREEN]: "success",
  [PillTheme.SOLID_LIGHT_BLUE]: "blue",
  [PillTheme.SOLID_NAVY]: "indigo",
  [PillTheme.SOLID_BLACK]: "black",
  [PillTheme.SOLID_WHITE]: "white",
};

export const ConversationTagPill = memo(function ConversationTagPill({
  tag,
  xClicked,
  iconTrailing,
  showOverflow = false,
  badgeSize = "sm",
}: {
  tag: ConversationTagLike;
  xClicked?(): void;
  iconTrailing?: BadgeIcon;
  showOverflow?: boolean;
  badgeSize?: RedoBadgeSize;
}) {
  const icons = filterTruthy([
    iconTrailing,
    xClicked && { type: "icon" as const, onClick: xClicked, Icon: XIcon },
  ]);
  return (
    <div
      className={classNames(
        conversationTagInputCss.pillWrapper,
        showOverflow && conversationTagInputCss.showOverflow,
      )}
    >
      <RedoBadge
        color={BadgePillThemeToColorMapping[tag.pillTheme]}
        iconTrailing={icons.length > 0 ? icons : undefined}
        size={badgeSize}
        text={tag.name}
      />
    </div>
  );
});
